export default __webpack_public_path__ + "static/media/error.cd2a113d.svg";